import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './services/auth';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Expedientes from './pages/Expedientes';
import ExpedienteDetail from './pages/ExpedienteDetail';
import AyudaN63 from './pages/AyudaN63';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import './styles.css';

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
                        <Route index element={<Dashboard />} />
                        <Route path="expedientes" element={<Expedientes />} />
                        <Route path="expedientes/:id" element={<ExpedienteDetail />} />
                        <Route path="ayuda" element={<AyudaN63 />} />
                    </Route>
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
